module.exports = __webpack_public_path__ + "img/northport.c18b9566.png";